import { FormFields } from "@/types";
import { countryList } from "@/lib/helpers/listHelpers";
import { $t } from "@/lib/helpers/i18nHelper";

export const fields: FormFields = [
  {
    name: "firstName",
    title: $t("First name")
  },
  {
    name: "lastName",
    title: $t("Last name")
  },
  {
    name: "address",
    title: $t("Address")
  },
  {
    name: "phone",
    title: $t("Phone number")
  },
  {
    name: "zip",
    title: $t("Zip code")
  },
  {
    name: "country",
    title: $t("Country"),
    type: "autocomplete",
    list: countryList
  },
  {
    name: "city",
    title: $t("City")
  },
  {
    name: "state",
    title: $t("State")
  }
];
